import React, { useState, useEffect } from 'react';
import './LandingPage.css';
import logoTipografia from '../../assets/img/tipografia-black.png';
import logoImagotipo from '../../assets/img/imagotipo-logo.png';

import { CutIconWhite, DeliveryIconWhite, MeatIconWhite} from '../ServiceIcons';


import heroImg1 from '../../assets/img/landing-hero-img.jpg';
import heroImg2 from '../../assets/img/landing-hero-02-img.jpg';
import heroImg3 from '../../assets/img/landing-hero-03-img.jpg';
import heroImg4 from '../../assets/img/landing-hero-04-img.jpg';

import carneImg from '../../assets/img/icons-meat.png';
import corteImg from '../../assets/img/icons-knife.png';
import deliveryImg from '../../assets/img/icons-delivery.png';


const LandingPage = ({ onEntrarAlChat }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [heroImg1, heroImg2, heroImg3, heroImg4];


  // 🧹 GUARDIA DE SEGURIDAD: Limpieza fulminante al pisar el Home
  useEffect(() => {
    console.log("🧼 Limpiando residuos de clientes anteriores al cargar el Home...");
    
    // 1. Matamos el localStorage
    localStorage.clear();

    // 2. Borramos las Cookies por si el servidor PHP dejó una sesión colgada
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
  }, []); // Los corchetes vacíos aseguran que se ejecute una sola vez cuando aparece el Home

 
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 5000); 
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="landing-wrapper">
      <div className="top-bar">
        <div className="contact-info">
         
        </div>
      </div>

      <nav className="main-nav">
        <div className="logo-container">
          <div className="icon-circle-red">
            <img src={logoImagotipo} className="logo-icon-img" alt="Icono" />
          </div>
          <img src={logoTipografia} className="logo-text-black" alt="Clavelina Carnes" />
        </div>
        <ul className="nav-links">
          <li>Inicio</li>
         
          <li className="active" onClick={onEntrarAlChat}>Hacer Pedido</li>
        </ul>
      </nav>

      
      <header className="hero-section">
        {images.map((img, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Su clave en carnes jugosas</h1>
            <button className="cta-button" onClick={onEntrarAlChat}>
              PEDIR AHORA POR CHAT →
            </button>
          </div>
        </div>

       
        <div className="slide-dots">
          {images.map((_, i) => (
            <span 
              key={i} 
              className={`dot ${i === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(i)}
            ></span>
          ))}
        </div>
      </header>

      <section className="services-section">
  <h2 className="section-title">Nuestros Servicios</h2>
  <div className="services-grid">
    
    
    <div className="service-card dark">
      <div className="image-wrapper">
        <img 
          src={carneImg} 
          alt="Selección de carnes" 
          className="service-image"
        />
        <div className="image-overlay"></div>
      </div>
      <div className="service-content">
        <h3>Elige tu Carne</h3>
        <p>Selecciona entre Res, Pollo o Cerdo de la mejor calidad nacional.</p>
      </div>
    </div>
  
    <div className="service-card red">
      <div className="image-wrapper">
        <img 
          src={corteImg} 
          alt="Corte de carne profesional" 
          className="service-image"
        />
        <div className="image-overlay"></div>
      </div>
      <div className="service-content">
        <h3>Corte a tu Gusto</h3>
        <p>¿Molida, mechar o bistec? Tú decides cómo quieres recibirla.</p>
      </div>
    </div>

   
    <div className="service-card dark">
      <div className="image-wrapper">
        <img 
          src={deliveryImg} 
          alt="Servicio de delivery" 
          className="service-image"
        />
        <div className="image-overlay"></div>
      </div>
      <div className="service-content">
        <h3>Delivery Directo</h3>
        <p>Recibe tu pedido en la puerta de tu casa de forma rápida y segura.</p>
      </div>
    </div>
  </div>
</section>
    </div>
  );
};

export default LandingPage;